/** The default anchor. It is omitted from the URL when selected. */
export const DEFAULT_ANCHOR = "PAX";

/** Resolve the anchor from a URL query string, falling back to the default. */
export function anchorFromSearch(search: string): string {
    return (new URLSearchParams(search).get("anchor") || DEFAULT_ANCHOR).toUpperCase();
}

/** Normalise a pathname the way react-router matches it: case-insensitive, optional trailing slash. */
export function normalizePathname(pathname: string): string {
    const lower = pathname.toLowerCase();
    return lower.length > 1 ? lower.replace(/\/+$/, "") || "/" : lower;
}

/**
 * Routes whose content depends on the anchor. Keep in sync with `App.tsx`.
 * `/` immediately redirects to `/top`, carrying the anchor along, so it
 * counts as an anchor page too.
 */
const ANCHOR_PATHS = new Set(["/", "/top", "/analysis"]);

export function isAnchorPage(pathname: string): boolean {
    return ANCHOR_PATHS.has(normalizePathname(pathname));
}
